<script setup>
import LinkButton from '@/Components/Button/Link.vue';
import MediaWithPopup from '@/Components/MediaWithPopup.vue';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();
const props = defineProps({
    location: Object,
});
</script>

<template>
    <div class="aspect-h-1 aspect-w-1 h-0 w-full overflow-hidden rounded bg-white">
        <MediaWithPopup
            v-if="location.profile_media"
            :media="location.profile_media"
            classes="object-cover w-full h-full"
        />
        <div
            :class="{
                'opacity-0': !location.restricted,
            }"
            class="pointer-events-none z-10 flex items-center justify-center bg-red/60 text-4 font-bold uppercase text-white"
        >
            {{ t('Blocked') }}
        </div>
    </div>

    <LinkButton
        :href="`tel:${location.phone_number}`"
        :text="location.phone_number"
        icon="/icon/chat.svg"
        white
    />

    <LinkButton
        white
        icon="/icon/mail.svg"
        :href="`mailto:${location.administration_email}`"
        :text="location.administration_email"
    />
    <LinkButton
        href=""
        icon="/icon/chat.svg"
        text="not implemented yet"
        white
    />

    <slot />
</template>
